$(function () {
    $('[js-item-header]').click(function () {
        var Number = $(this).attr('js-item-header');
        $(this).toggleClass('vacancies__item-header_active');
        $('[js-arrow]').each(function () {
            if ($(this).attr('js-arrow') == Number) {
                $(this).toggleClass('vacancies__item-arrow_active');
            }
        });
        $('[js-body]').each(function () {
            if ($(this).attr('js-body') == Number) {
                $(this).stop().slideToggle();
            }
        })
    })
})